/**
 * A calm empty state for screens that need a prior action (e.g. Results / Ledger before a run).
 * Headline + supporting line + an optional call-to-action button.
 */
export interface EmptyStateProps {
  title: string;
  body: string;
  actionLabel?: string;
  onAction?: () => void;
}

export function EmptyState({
  title,
  body,
  actionLabel,
  onAction,
}: EmptyStateProps): React.ReactElement {
  return (
    <div
      className="card reveal"
      style={{ textAlign: 'center', padding: 'var(--sp-16) var(--sp-8)' }}
    >
      <h2 style={{ marginBottom: 'var(--sp-2)' }}>{title}</h2>
      <p style={{ color: 'var(--ink-muted)', maxWidth: 460, margin: '0 auto var(--sp-6)' }}>
        {body}
      </p>
      {actionLabel !== undefined && onAction !== undefined && (
        <button type="button" className="btn btn--primary" onClick={onAction}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}
